import * as React from 'react'

import DashboardAdmin from './dashboard/DashboardAdmin'

import Navbar from '../components/Navbar'
import StyledContainer from '../components/StyledContainer'

const Dashboard: React.SFC = () => (
  <div>
    <Navbar />
    <StyledContainer>
      <DashboardAdmin />
    </StyledContainer>
  </div>
)

export default Dashboard



// WEBPACK FOOTER //
// ./src/screens/Dashboard.tsx